import type { ReactNode } from 'react';

export type CircularPercentageInfoClassNames = Partial<Record<'childContainer' | 'container', string>>;

export interface CircularPercentageInfoProps {
  readonly value: number;
  readonly title: string;
  readonly subtitle?: string;
  readonly children?: ReactNode;
  readonly inverse?: boolean;
  readonly componentsClassNames?: CircularPercentageInfoClassNames;
}
